import { render, staticRenderFns } from "./DisbursementGroupAction.vue?vue&type=template&id=388ab957"
import script from "./DisbursementGroupAction.vue?vue&type=script&lang=js"
export * from "./DisbursementGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports